<div *ngIf="activeBehavior"><i [ngClass]="icon" class="pi mr-2 text-gray-600"></i> {{activeBehavior.name}}</div>
